import { type FieldInputProps, useField } from 'formik';
import startCase from 'lodash/startCase';
import { useId } from 'react';

import { FormField } from 'common';

import { type TagAutocompleteCommonProps, TagAutocompleteInner } from './Inner';

interface TagAutocompleteFieldProps extends TagAutocompleteCommonProps {
  name: string;
  label: string;
  placeholder?: string;
  isFreeSolo?: boolean;
  isMultiple?: boolean;
  errorMessage?: string;
}

export function TagAutocompleteField(props: TagAutocompleteFieldProps) {
  const {
    label,
    name,
    placeholder = `Type to search ${startCase(label)}...`,
    isMultiple = false,
    isFreeSolo = false,
    optionDescriptions,
    ...rest
  } = props;

  const fieldId = useId();
  const [field, meta] = useField<string | string[]>(name);

  const selectedDescription =
    !isMultiple && !isFreeSolo && typeof field.value === 'string'
      ? optionDescriptions?.[field.value]
      : undefined;

  const helperText = isFreeSolo
    ? 'Type to search, or select "Add ..." to create a new tag'
    : selectedDescription;

  if (isMultiple) {
    return (
      <FormField
        id={fieldId}
        label={label}
        error={meta.touched && meta.error ? meta.error : undefined}
        helperText={helperText}
      >
        <TagAutocompleteInner
          {...rest}
          optionDescriptions={optionDescriptions}
          placeholder={isFreeSolo ? undefined : placeholder}
          isFreeSolo={isFreeSolo}
          isMultiple={true}
          fieldId={fieldId}
          field={field as FieldInputProps<string[]>}
        />
      </FormField>
    );
  } else {
    return (
      <FormField
        id={fieldId}
        label={label}
        error={meta.touched && meta.error ? meta.error : undefined}
        helperText={helperText}
      >
        <TagAutocompleteInner
          {...rest}
          optionDescriptions={optionDescriptions}
          placeholder={placeholder}
          isFreeSolo={isFreeSolo}
          isMultiple={false}
          fieldId={fieldId}
          field={field as FieldInputProps<string>}
        />
      </FormField>
    );
  }
}
